import * as XLSX from 'xlsx';

export const exportToExcel = (data: any[], columns: { key: string; label: string }[], fileName: string) => {
    const wsData: any[][] = [columns.map(c => c.label)];
    data.forEach(row => {
        wsData.push(columns.map(c => row[c.key] ?? ''));
    });
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    // Auto-width columns
    ws['!cols'] = columns.map((_, i) => ({ wch: Math.max(columns[i].label.length, 15) }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Dados');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
};
